import { logAct } from "@/api/log";

export default {
  namespaced: true,
  actions: {
    addLog(context, m) {
      let data;
      if (typeof m === "string") {
        data = {
          m,
          t: new Date().valueOf(),
        };
      } else {
        data = {
          ...m,
          t: new Date().valueOf(),
        };
      }
      if (m === "退出") {
        data.p = window.location.href;
      }
      logAct(data);
    }
  }
};